import React, { createContext, useContext, useEffect, useState } from 'react';
import { flushSync } from 'react-dom';
/**
 * @internal
 */
export const PrintContext = createContext({
    printing: false,
});
/**
 * @internal
 */
export const PrintProvider = ({ children }) => {
    const [printing, setPrinting] = useState(false);
    useEffect(() => {
        const isSSR = typeof window === 'undefined';
        const onBeforePrint = () => {
            // this is needed because window.print() is expecting  synchronous execution so with React it needs to be flushed to keep styling in-sync
            flushSync(() => {
                setPrinting(true);
            });
        };
        const onAfterPrint = () => {
            setPrinting(false);
        };
        if (isSSR) {
            // do nothing
            return () => { };
        }
        else {
            window.addEventListener('beforeprint', onBeforePrint);
            window.addEventListener('afterprint', onAfterPrint);
        }
        return () => {
            window.removeEventListener('beforeprint', onBeforePrint);
            window.removeEventListener('afterprint', onAfterPrint);
        };
    }, []);
    return React.createElement(PrintContext.Provider, { value: { printing } }, children);
};
/**
 *
 * Listen in when a print preview/modal is opened and expand all closed components that should show their content.
 *
 *
 * ```js
 * import { usePrint } from '@polestar/component-warehouse-react';
 *
 * const MyComponent = () => {
 *    const { printing } = usePrint();
 *
 *    return ...
 * }
 *  ```
 *
 * @returns PrintContext
 * @storybook Hooks/usePrint
 *
 */
export const usePrint = () => useContext(PrintContext);
